import axios from 'axios';
import store from '../../store';
import iView from 'iview';
import router from '../../router';
import Toast from "mint-ui/packages/toast/src/toast";
let instance = null;

if (process.env.NODE_ENV === 'development') {
  instance = axios.create({
    // baseURL: 'http://文玄.com/' // api context
    baseURL: '/' // api context
  });
} else {
  instance = axios.create({
    // baseURL: 'http://文玄.com/' // api context
    baseURL: '/' // api context
  });
}

instance.defaults.timeout = 50000; // timeout

// instance.defaults.withCredentials = true;
// instance.defaults.headers = {
//   'Content-type': 'application/x-www-form-urlencoded'
// }

// request interceptors
instance.interceptors.request.use(
  // request => {
  //   return request;
  // },
  config => {
    if (localStorage.getItem('token')) {
      config.headers['Access-Token'] = localStorage.getItem('token');
    }
    if (sessionStorage.getItem('token')) {
      config.headers['Access-Token'] = window.sessionStorage.getItem('token');
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log("request", error);
    Promise.reject(error);
  },
);
/*instance.interceptors.request.use(
  request => {
    return request;
  },
  config => {
    // if token exist, add Access-Token to request header
    if (store.state.user.token) {
      config.headers['Access-Token'] = store.state.user.token;
      config.headers['id'] = store.state.user.id;
    } else {
      let result = store.dispatch("GET_USER_EXIST");
      result.then((flag) => {
        if (flag) {
          store.dispatch("GET_USER_CACHE");
          if (store.state.user.token) {
            config.headers['Access-Token'] = store.state.user.token;
            config.headers['id'] = store.state.user.id;
          }
        }
      })
    }
    // change data to formData
    let keys = Object.keys(config.data);
    let formData = new FormData();
    for (let i = 0, len = keys.length; i < len; i++) {
      let key = keys[i];
      formData.append(key, config.data[key]);
    }
    // config.data = qs.stringify(config.data);
    config.data = formData;
    return config;
  },
  error => {
    // Do something with request error
    console.log("request", error);
    // iView.Notice.warning({
    //   title: `"An error occurred.`
    // });
    Promise.reject(error);
  },
);*/

// response interceptors response data format {code: 200, data: {}} or {code: 400, message: "error"}
instance.interceptors.response.use(
  response => {
    let res = response.data;
    let code = res.code;
    if (code) {
      if (res.code === 200) {
        let data = res.data;
        if (data === undefined || data === '' || data === null) {
          data = 0
        }
        return data
      } else if (res.code === 401) {
        router.push("/login")

      } else {
        iView.Notice.warning({
          title: `${res.message}`,
        });
        return false
      }
    }
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/libs/http/axios.js